import { PATHWAY } from "@/constants/testIds";
import RuntimeIndicator from "@/components/pathway/RuntimeIndicator";

const NAV = [
  { id: "mission", label: "Mission", testId: PATHWAY.navMission },
  {
    id: "governance-centre",
    label: "Governance Centre",
    testId: PATHWAY.navGovernanceCentre,
  },
  { id: "workflow", label: "Workflow", testId: PATHWAY.navWorkflow },
  { id: "boundaries", label: "Boundaries", testId: PATHWAY.navBoundaries },
  { id: "scenario", label: "Scenario", testId: PATHWAY.navScenario },
  { id: "outputs", label: "Outputs", testId: PATHWAY.navOutputs },
  { id: "adoption", label: "Adoption", testId: PATHWAY.navAdoption },
  { id: "intake", label: "Intake", testId: PATHWAY.navIntake },
];

export default function TopNav() {
  return (
    <header className="sticky top-0 z-40 border-b hairline bg-[#0a0a0a]/90 backdrop-blur-sm">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-4 md:px-12">
        <a
          href="#top"
          data-testid={PATHWAY.navWordmark}
          className="group flex flex-col leading-none"
          aria-label="Emerging Risk Lab Pathway"
        >
          <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-neutral-500 group-hover:text-amber-500 transition-colors">
            KATLAS · Insurance pathway
          </span>
          <span className="mt-1 font-serif text-lg text-neutral-100 tracking-tight">
            Emerging Risk Lab Pathway
          </span>
        </a>

        <nav className="hidden items-center gap-5 xl:flex">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              data-testid={n.testId}
              className="editorial-link font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-400 hover:text-neutral-100"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <RuntimeIndicator />
          <a
            href="#intake"
            data-testid={PATHWAY.navSponsorCta}
            className="border border-amber-700 bg-amber-700 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.22em] text-white transition-colors hover:bg-amber-600 whitespace-nowrap"
          >
            Sponsor the pathway
          </a>
        </div>
      </div>
    </header>
  );
}
